module.exports = __webpack_public_path__ + "media/src/images/icons/profile/blue-e68aeb537c77cb7e40086ea2f3c60ac4.svg";